import { render, staticRenderFns } from "./educationAdd.vue?vue&type=template&id=eeda6d5c"
import script from "./educationAdd.vue?vue&type=script&lang=js"
export * from "./educationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeda6d5c')) {
      api.createRecord('eeda6d5c', component.options)
    } else {
      api.reload('eeda6d5c', component.options)
    }
    module.hot.accept("./educationAdd.vue?vue&type=template&id=eeda6d5c", function () {
      api.rerender('eeda6d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationAdd.vue"
export default component.exports